function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".iceberg-aside_svg__st9{fill:#192f28}.iceberg-aside_svg__st13{fill:#fff}.iceberg-aside_svg__st14{fill:#23c386}.iceberg-aside_svg__st15{fill:#69e3b4}");

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-aside_svg__SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 31.315,
  y1: 80.063,
  x2: 97.797,
  y2: 152.702
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-aside_svg__SVGID_1_)",
  d: "M65 128l3.5 80 15.1-74.9L124 93.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-aside_svg__SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 116.144,
  y1: 181.071,
  x2: 46.535,
  y2: 162.662
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-aside_svg__SVGID_2_)",
  d: "M68.5 208l-20.6-35.7L65 128z"
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-aside_svg__SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 137.545,
  y1: 165.629,
  x2: 32.093,
  y2: 134.653
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-aside_svg__SVGID_3_)",
  d: "M47.9 172.3l-31.2-37.1L6 93.9 65 128z"
});

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-aside_svg__SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 91.796,
  y1: 223.75,
  x2: 84.939,
  y2: 156.894
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-aside_svg__SVGID_4_)",
  d: "M68.5 208l37.5-57.1-22.4-17.8z"
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-aside_svg__SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 108.981,
  y1: 164.276,
  x2: 103.823,
  y2: 113.981
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef7"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-aside_svg__SVGID_5_)",
  d: "M83.6 133.1L124 93.9l-18 57z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#cfd6ec",
  d: "M35.6 30.1l29.4-17 29.4 17-29.4 17z"
});

var _ref13 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-aside_svg__SVGID_6_",
  gradientUnits: "userSpaceOnUse",
  x1: 0.267,
  y1: 107.012,
  x2: 97.493,
  y2: 52.649
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-aside_svg__SVGID_6_)",
  d: "M65 47.1V128L6 93.9l29.6-63.8z"
});

var _ref15 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-aside_svg__SVGID_7_",
  gradientUnits: "userSpaceOnUse",
  x1: 45.543,
  y1: 79.05,
  x2: 126.042,
  y2: 79.05
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#iceberg-aside_svg__SVGID_7_)",
  d: "M65 47.1l29.4-17v34L124 81.2v12.7L65 128z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2d327e",
  strokeMiterlimit: 10,
  d: "M-.1 90.4L65 128l65.1-37.6"
});

var _ref18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_720_",
  className: "iceberg-aside_svg__st9",
  d: "M86.9 21.9C84 19 71.4 12.6 65.6 14.2c-1.4.5-2.9 1-4.4 1.3l28.6 13.2c-.1-2.5-1.1-5-2.9-6.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_713_",
  className: "iceberg-aside_svg__st9",
  d: "M89.4 23.7c-4.2-1.5-8-3.2-10.8-2.4-2.8.9-3.7 5.5-2.8 6.2.6.5.6-1.2 2.2-1.5-.8 1.3.1 3.6.8 4.1.6.5.1-2.1 1.7-2.4-.1 1.6 1.1 2.7 1.6 2.4.3-.2-.5-1.9 1-2.4 1.1 1.1 6.4 5.2 9.3 3.1 2.7-2.1.8-5.7-3-7.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_684_",
  className: "iceberg-aside_svg__st9",
  d: "M65.1 12.3c3.8 2.3 7.5 4.1 8.7 6.7 1.5 3.4-2.1 6.6-3 6.5-.5-.1.4-2-.4-2.8-.3 1.9-2.5 2.5-2.9 2.3-.4-.2.9-1.8.3-3.2-1.2 1.3-3.4 1-3.5.6-.1-.5 2.4-1.3 1.8-2.4 0 0-8.1-1.6-8.3-5.2-.2-3.6 3.8-4.5 7.3-2.5z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-aside_svg__Path_1_",
  gradientUnits: "userSpaceOnUse",
  x1: -744.505,
  y1: 289.515,
  x2: -745.032,
  y2: 290.387,
  gradientTransform: "matrix(15.1776 21.0282 19.404 -14.0053 5759.737 19755.406)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#3fb984",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_683_",
  d: "M89.4 23.7c-4.2-1.5-8-3.2-10.8-2.4-2.8.9-3.7 5.5-2.8 6.2.6.5.6-1.2 2.2-1.5-.8 1.3.1 3.6.8 4.1.6.5.1-2.1 1.7-2.4-.1 1.6 1.1 2.7 1.6 2.4.3-.2-.5-1.9 1-2.4 1.1 1.1 6.4 5.2 9.3 3.1 2.7-2.1.8-5.7-3-7.1z",
  fill: "url(#iceberg-aside_svg__Path_1_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-aside_svg__Path_2_",
  gradientUnits: "userSpaceOnUse",
  x1: -763.552,
  y1: 292.006,
  x2: -764.012,
  y2: 292.504,
  gradientTransform: "matrix(17.3995 24.1067 14.5566 -10.5066 9101.422 21505.25)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#3fb984",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_681_",
  d: "M65.1 12.3c3.8 2.3 7.5 4.1 8.7 6.7 1.5 3.4-2.1 6.6-3 6.5-.5-.1.4-2-.4-2.8-.3 1.9-2.5 2.5-2.9 2.3-.4-.2.9-1.8.3-3.2-1.2 1.3-3.4 1-3.5.6-.1-.5 2.4-1.3 1.8-2.4 0 0-8.1-1.6-8.3-5.2-.2-3.6 3.8-4.5 7.3-2.5z",
  fill: "url(#iceberg-aside_svg__Path_2_)"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_680_",
  className: "iceberg-aside_svg__st9",
  d: "M95.3 1c-.1 0-.2 0-.3.1-2.1 1.6-4.5 2.6-7.1 3-.7.1-1.3.3-1.9.5-.4.3-.8.6-1.1 1-1.7-1.9-4.4-2.8-7.9-2.7h-.7c-3.5.2-6.1 1.3-7.6 3.4-.3-.3-.7-.6-1.2-.8-.6-.2-1.3-.3-2-.4-2.5-.1-5.1-.9-7.3-2.2-.2-.1-.5-.1-.6.1-.2.2-.2.4-.1.6.1.2.5 1 .6 1.3.5 1 2 3.1 2.5 5.7 0 .2.1.5.2.8l1.5.2-1.2 1c.4 1 1 2 1.9 2.7l1.7-1-.6 1.6c1 .3 2 .4 3 .2-.1.5-.1 1.1-.1 1.7.1.9.6 1.7 1.4 2.2 1 .7 2.6 1.2 4.8 1.5.4.1.8.4.9.7.2.6 1.3.8 3.4.7h.1c.9 0 1.8-.2 2.6-.4.3-.1.6-.3.7-.6.2-.4.5-.7.9-.8 2.3-.5 3.9-1.2 4.8-2.1.7-.6 1-1.5 1-2.4-.1-.5-.1-1-.3-1.5h1.2l-.3-1.5 1.1 1.3.1-.9.7.7c.9-.4 1.6-1.1 2.1-1.9l-1.8-1.4 2.3.4c.3-.7.5-1.4.6-2.1l-1-.5 1.1-.2-1.5-.6 1.6-.1c.3-2.3 1.5-4.2 1.8-5.2.1-.2.4-1.1.5-1.3v-.2c0-.2 0-.3-.1-.4-.1-.2-.3-.2-.4-.2z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iceberg-aside_svg__Path_3_",
  gradientUnits: "userSpaceOnUse",
  x1: -856.119,
  y1: 281.802,
  x2: -855.843,
  y2: 281.359,
  gradientTransform: "matrix(49.5424 24.3527 19.9731 -40.6328 36860.406 32291.787)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#3fb984",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_679_",
  d: "M95.3 1c-.1 0-.2 0-.3.1-2.1 1.6-4.5 2.6-7.1 3-.7.1-1.3.3-1.9.5-.4.3-.8.6-1.1 1-1.7-1.9-4.4-2.8-7.9-2.7h-.7c-3.5.2-6.1 1.3-7.6 3.4-.3-.3-.7-.6-1.2-.8-.6-.2-1.3-.3-2-.4-2.5-.1-5.1-.9-7.3-2.2-.2-.1-.5-.1-.6.1-.2.2-.2.4-.1.6.1.2.5 1 .6 1.3.5 1 2 3.1 2.5 5.7 0 .2.1.5.2.8l1.5.2-1.2 1c.4 1 1 2 1.9 2.7l1.7-1-.6 1.6c1 .3 2 .4 3 .2-.1.5-.1 1.1-.1 1.7.1.9.6 1.7 1.4 2.2 1 .7 2.6 1.2 4.8 1.5.4.1.8.4.9.7.2.6 1.3.8 3.4.7h.1c.9 0 1.8-.2 2.6-.4.3-.1.6-.3.7-.6.2-.4.5-.7.9-.8 2.3-.5 3.9-1.2 4.8-2.1.7-.6 1-1.5 1-2.4-.1-.5-.1-1-.3-1.5h1.2l-.3-1.5 1.1 1.3.1-.9.7.7c.9-.4 1.6-1.1 2.1-1.9l-1.8-1.4 2.3.4c.3-.7.5-1.4.6-2.1l-1-.5 1.1-.2-1.5-.6 1.6-.1c.3-2.3 1.5-4.2 1.8-5.2.1-.2.4-1.1.5-1.3v-.2c0-.2 0-.3-.1-.4-.1-.2-.3-.2-.4-.2z",
  fill: "url(#iceberg-aside_svg__Path_3_)"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_678_",
  className: "iceberg-aside_svg__st9",
  d: "M90.2 5.9c-2 .9-3.6 1.9-3.9 3.3-.3 1.5.3 3.4.8 5.1.1.2.1.4.2.6.4 0 .8.1 1.2 0l-.3-1.5 1.1 1.3.1-.9.7.7c.9-.4 1.6-1.1 2.1-1.9l-1.8-1.4 2.3.4c.3-.7.5-1.4.6-2.1l-1-.5 1.1-.2-1.5-.6 1.6-.1C93.8 5.9 95 4 95.3 3c.1-.2.4-1.1.5-1.3C94.3 4 92.2 5 90.2 5.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_677_",
  className: "iceberg-aside_svg__st9",
  d: "M77.6 4.6c.3-.2 1.6-.1 1.6-.1.3 0 .5.3.4.4-.4.3-.9.4-1.3.3-.7-.1-.9-.4-.7-.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_676_",
  className: "iceberg-aside_svg__st9",
  d: "M77.6 5.8c.7 0 .4.7-.1.8-.4.1-1.1-.1-1-.4.1-.2.7-.4 1.1-.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_675_",
  className: "iceberg-aside_svg__st9",
  d: "M75.3 4.6c.5 0 1 .2 1.2.7.1.3-.3.4-1.2.6-.9.2-1.7-.2-1.8-.5.1-.3 1.2-.8 1.8-.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_674_",
  className: "iceberg-aside_svg__st9",
  d: "M67.5 10.1c-.4-.7-.8-1.8-3.2-2.6-1-.2-1.9-.6-2.9-1-1.5-.8-2.8-1.8-4-3 .1.2.5 1 .6 1.3.5 1 2 3.1 2.5 5.7 0 .2.1.5.2.8l1.5.2-1.2 1c.4 1 1 2 1.9 2.7l1.7-1-.6 1.6c1 .4 2 .4 3 .2 0-.2.1-.4.1-.6.5-1.7 1.1-3.9.4-5.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_673_",
  className: "iceberg-aside_svg__st9",
  d: "M83.8 14.8c0 .8-.6 1.3-2.1 1.4h-.6c-1.6 0-2.4-.2-4.1-.2-1.8.1-2.5.3-4.1.5h-.6c-1.5 0-2.1-.4-2.2-1.2-1.2 1.1.5 2.5 1.7 3 1.6.6 3.3.9 5 .8h.5c1.7 0 3.4-.4 5-1.2 1.2-.6 2.7-2.1 1.5-3.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_672_",
  className: "iceberg-aside_svg__st13",
  d: "M70.9 17.4c-.4-.3-1-.8-.9-1.4.3.4.8.7 1.3.7l-.4.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_671_",
  className: "iceberg-aside_svg__st13",
  d: "M71.8 18l-.6-.3.4-.7.2 1c.1 0 0 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_670_",
  className: "iceberg-aside_svg__st13",
  d: "M72.2 18l-.2-1.1v-.1h.9s.1 0 .1.1v.1l-.8 1c.1.1 0 .1 0 0 0 .1 0 .1 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_669_",
  className: "iceberg-aside_svg__st13",
  d: "M74.1 18.7l-1.5-.3s-.1 0-.1-.1v-.1c.2-.3.8-1.2.9-1.3l.7 1.7v.1c.1 0 .1 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_668_",
  className: "iceberg-aside_svg__st13",
  d: "M74.7 18.6l-.8-1.8v-.1l.1-.1.6-.1c.3-.1.7-.1 1-.2h.1v.1l-1 2.2c-.1 0-.1 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_667_",
  className: "iceberg-aside_svg__st13",
  d: "M76.6 18.8h-1.4s-.1 0-.1-.1v-.1l.9-1.8.7 1.9s0 .1-.1.1c.1.1 0 .1 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_666_",
  className: "iceberg-aside_svg__st13",
  d: "M77.1 18.6c0 .1 0 .1 0 0l-.9-2.2v-.1l.1-.1h1.4s.1 0 .1.1v.1l-.7 2.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_665_",
  className: "iceberg-aside_svg__st13",
  d: "M79 18.6c-.4.1-.9.1-1.4.2 0 0-.1 0-.1-.1v-.1l.6-1.9h.1l1 1.8v.1H79z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_664_",
  className: "iceberg-aside_svg__st13",
  d: "M79.4 18.4l-1.2-2v-.1l.1-.1c.4 0 .7 0 1 .1l.6.1h.1v.1l-.6 1.9c.1 0 .1 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_663_",
  className: "iceberg-aside_svg__st13",
  d: "M81.5 18c-.5.2-1 .3-1.4.4H80v-.1l.6-1.7h.1l1 1.3c-.2-.1-.1 0-.2.1 0-.1 0 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_662_",
  className: "iceberg-aside_svg__st13",
  d: "M82 16.5l-.1 1.1-.9-1.1v-.1l.1-.1h.8c0 .1 0 .1.1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_661_",
  className: "iceberg-aside_svg__st13",
  d: "M82.9 17.2c-.2.1-.4.3-.6.4h-.1l.1-1.1s0-.1.1 0l.5.7s-.1 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_660_",
  className: "iceberg-aside_svg__st13",
  d: "M83.4 16.7c0 .1-.1.1-.2.2l-.5-.6c.3-.1.5-.2.8-.3.2-.1.3-.3.4-.5v.2c0 .4-.2.8-.5 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_659_",
  className: "iceberg-aside_svg__st9",
  d: "M69.4 10.3c1.2-.1 2.7 1.2 5 2 .8.3 1.7.5 1.9.5-.4.1-.9.2-1.3.2-.5.9-1.4 1.4-2.4 1.4-1.2.1-2.4-.7-2.6-1.9-.1-.3-.1-.6-.1-.9.7-.1 1.5 0 2.2.2-.7-.4-1.6-.7-2.4-.7-.4 0-.8.1-1.2.2 0 .1.2-.9.9-1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_658_",
  className: "iceberg-aside_svg__st9",
  d: "M84.4 10.6c-.8.1-1.6.5-2.4.9.7-.2 1.4-.3 2.2-.3v.9c-.1 1.2-1.2 2.2-2.5 2.1-1 .1-1.9-.4-2.5-1.2-.5 0-.9 0-1.3-.1.1 0 1-.3 1.8-.7 2.2-1 3.7-2.4 4.9-2.4.7 0 1 1 1 1-.4-.2-.8-.2-1.2-.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_657_",
  className: "iceberg-aside_svg__st14",
  d: "M82 11.5c.7-.2 1.4-.3 2.2-.3v.9c-.1 1.2-1.2 2.2-2.5 2.1-1 .1-1.9-.4-2.5-1.2 1-.4 2-.9 2.8-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_656_",
  className: "iceberg-aside_svg__st14",
  d: "M74.9 13.1c-.5.9-1.4 1.4-2.4 1.4-1.2.1-2.4-.7-2.6-1.9-.1-.3-.1-.6-.1-.9.7-.1 1.5 0 2.2.2 1 .5 1.9.9 2.9 1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_655_",
  className: "iceberg-aside_svg__st15",
  d: "M74 13.5c.1-.5-2.4-1-2.4-1-.8-.3-.7.2-.6.5.2.2.6 1.1 1.4 1.2.8.1 1.6-.4 1.6-.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_654_",
  className: "iceberg-aside_svg__st15",
  d: "M83.3 12.5c-.2.6-.7 1.1-1.3 1.3-.7.2-1.5-.2-1.6-.6-.1-.4 2.3-1.2 2.3-1.2.3 0 .9-.1.6.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_653_",
  className: "iceberg-aside_svg__st13",
  d: "M73.1 12.9s.8.2.8.5c0 .4-1.2-.4-1.5-.5-.3 0 0-.2.7 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "iceberg-aside_svg__Path_617_",
  className: "iceberg-aside_svg__st13",
  d: "M81.2 12.6s-.8.2-.8.6c0 .4 1.1-.5 1.4-.6.4-.1.1-.2-.6 0z"
}));

function SvgIcebergAside(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iceberg-aside_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 130.6 207",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

export default "data:image/svg+xml;base64,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";
export { SvgIcebergAside as ReactComponent };